import React, { Fragment } from 'react';

const DividersUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Dividers should be noticeable in a layout, but not jarring.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Dividers help users understand how content is organized by establishing visual rhythm and hierarchy. Using thin horizontal lines to create visual separation between titles and content, sections of content and to group content together.</p>
        </div>
      </article>

    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Using Dividers</h2>
          <p>Carefully consider the necessity of using a divider in your layout. There are often other design elements in a layout that can create visual hierarchy without adding additional line elements.</p>
          <p>For example, you don’t need dividers to define a group of image-based content because the grid of images itself creates visual distinction.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default DividersUsage;


// WEBPACK FOOTER //
// ./src/containers/elements/Dividers/DividersUsage.js